import { constants } from "../../misc/constants";
import Scenario2 from "./Scenario2";
import { SbarUIConfig } from "../../components/ui/SbarUI";
import { FullPageQuizQuestion } from "../../components/ui/FullPageQuizUI";
import { TransformUIConfig } from "../../components/ui/TransformUI";
import MedsurgBaseScenarioPart from "../MedsurgBaseScenarioPart";
import { Window508Type } from "../MedsurgBaseScenario";

export default class Scenario2Part6 extends MedsurgBaseScenarioPart {

	chapterIds = {
		chapterCinematic1: 'medsurg-cinematic-2-1',
        chapterCinematic48: 'medsurg-cinematic-2-48',
        chapterCinematic49: 'medsurg-cinematic-2-49',
        chapterCinematic50: 'medsurg-cinematic-2-50',
		chapterCinematic51: 'medsurg-cinematic-2-51',
        chapterCinematic52: 'medsurg-cinematic-2-52',
        chapterCinematic53: 'medsurg-cinematic-2-53',
        chapterCinematic54: 'medsurg-cinematic-2-54',
        chapterCinematic55: 'medsurg-cinematic-2-55', //NEED ANIM REPLACED, NEW CLIP NOT SHOWING FACE SO AUDIO CAN BE ATTACHED TO VIDEO
        chapterCinematic56: 'medsurg-cinematic-2-56',
        chapterCinematic57: 'medsurg-cinematic-2-57',
        chapterCinematic58: 'medsurg-cinematic-2-58',
        chapterCinematic60: 'medsurg-cinematic-2-60',
		chapterCinematic61: 'medsurg-cinematic-2-61',
		chapterCinematic62: 'medsurg-cinematic-2-62',
        chapterCinematic69: 'medsurg-cinematic-2-69',
        chapterCinematic70: 'medsurg-cinematic-2-70',
        chapterCinematic76: 'medsurg-cinematic-2-76',
	}
	constructor(scenario: Scenario2, private onDone: () => void){
		super(scenario);
	}

	private PrInstanceID: string;
	private TalkInstanceID1: string;
	private ActionInstanceID1: string;
	private RememberDisplayed: boolean = false;
	private ActionInstanceID2: string;
	private ActionInstanceID3: string;
	private MoveInstanceID: string;

	private Talk1: boolean = false;
	private Talk2: boolean = false;
	private Talk3: boolean = false;
	private Talk4: boolean = false;
	private Talk5: boolean = false;
	private Talk6: boolean = false;
	private Action1: boolean = false;
	private Action2: boolean = false;
	private Action3: boolean = false;
	private Action4: boolean = false;
	private Action5: boolean = false;
	private Action6: boolean = false;
	private Action11: boolean = false;
	private Action12: boolean = false;
	private Action13: boolean = false;
	private Action14: boolean = false;
	private Action15: boolean = false;
	private Action21: boolean = false;
	private Action22: boolean = false;
	private Action23: boolean = false;
	private Action24: boolean = false;
	private Action31: boolean = false;
	private Action32: boolean = false;
	private Action33: boolean = false;
	private Action34: boolean = false;
	private Action35: boolean = false;

	private TalkCount: number = 0;
	private OldTalkCount: number = 0;
	private ActionCount: number = 0;
	private OldActionCount: number = 0;
	private PAbool: boolean = false;
	private DRbool: boolean = false;
	private CMSbool: boolean = false;
	private bedUp: boolean = false;

	public get partId(): string {
		return constants.scenarios.scenario2.parts.level2Part6.id;
	}

	public get videoUrl(): string[] {
		//return ['./assets/videos/scenario2/video3' + this.scenario.avatarIndx + '.mp4'];
		return ['./assets/videos/scenario2/video30.mp4'];
	}

	public start() {
		const context = this;
		this.RememberDisplayed = false;

		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
			title: 'Vitals - On Admission'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
			list: '<li>Temperature: 97.2</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
			list: '<li>Pulse: 98</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
			list: '<li>Respirations: 30</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
			list: '<li>Blood Pressure: 90/50</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
			list: '<li>Oxygen Saturation: 84% room air </li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
			title: 'Vitals - 15:00',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
			visit: context.scenario.visit1,
			lineBreak: true,
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezBasicID, {
			title: 'Patient Information',
			description: '<ul style=\"list-style-type:square\"><li>Enrique Ramirez, 32 years old, was brought to the ED following a motor vehicle accident in which he suffered fractures to the 5th and 6th ribs on the right side. He also suffered a right pneumothorax. Surgery was performed in the OR to place a chest tube.  He was admitted to the medical surgical unit 12 hours ago.</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezBasicID, {
			title: 'Patient History',
			description: '<ul style=\"list-style-type:square\"><li>no significant medical history.</li><li>receiving O2 at 2L/ min via nasal cannula.</li><li>Hispanic</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezBasicID, {
			title: 'Active Medications',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezBasicID, {
			title: 'Providers Orders',
			description: '<ul style=\"list-style-type:square\"><li>Hydromorphone – 1 mg every two hours as needed for pain</li><li>Ampicillan – 2 grams every 6 hours by IV</li><li>Normal saline – 100 mL/hr</li><li>Chest tube suction – -20cm of H2O</li><li>Patient should be instructed to breathe deeply and cough every hour</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezBasicID, {
			title: 'Dietary Restrictions',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezBasicID, {
			title: 'Other Observations',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezBasicID, {
			title: 'Post-Op Information',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});

		context.segment1Step1IntroWalking();
	}

	private segment1Step1IntroWalking() {
		var context = this;
		this.scenario.destroyAllUIInstances();
		context.scenario.displayHeader();
		this.scenario.playAmbientLoop(this.scenario.audioHall);
		this.playVideoChapter(this.chapterIds.chapterCinematic1, () => {
			context.segment1Step2ContinueRoom1();
		});
    }

	private segment1Step4Remember() {
		var context = this;
		this.scenario.update508Window(Window508Type.Remember);
		this.scenario.displayRemember(() => {
			this.scenario.update508Window(Window508Type.Main);
			this.RememberDisplayed = true;
			context.scenario.destroyAllUIInstances();
			//context.skipPart();
		});
	}
	//use when skipping part for testing
	private skipPart() {
		var context = this;
        this.scenario.displayModalPop(
			null,
            'Skipping to part 7',
            () => {
                context.scenario.destroyAllUIInstances();
                    context.segment1StepFinal();
            }
        );
	}

    private segment1Step2ContinueRoom1() {
		this.scenario.destroyAllUIInstances();
        var context = this;
        context.scenario.gameManager.environment.blurFadeIn();
        this.scenario.displayModalPop(
			null,
            'You have a new patient to visit in room 6',
            () => {
				this.scenario.stopAmbientLoop();
				this.scenario.playAmbientLoop(this.scenario.audioRoom);
				context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				this.playVideoChapter(this.chapterIds.chapterCinematic48, () => {}, true);
                context.PreloadUis();
				if(this.RememberDisplayed === false) {
					context.segment1Step4Remember();
				}
				this.scenario.displayFooter(() => this.PrInstanceID, () => this.TalkInstanceID1, () => this.ActionInstanceID1, '6', '9', false, false);
				context.TalkCount = 6;
				context.ActionCount = 9;
				context.getFooterCounts();
            }
        );
    }

	private segment1Part5Debrief() {
		var context = this;
		context.scenario.displayDebrief(2950, () => {
			localStorage.setItem('ignoreResumePopup', 'true');
			window.location.reload();
		}, () => {
			context.segment1StepFinal();
		});
	}

	private segment1StepFinal() {
        var context = this;
        context.scenario.destroyAllUIInstances();
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
			title: 'Vitals - 16:30'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
			visit: context.scenario.visit3,
			lineBreak: true,
		});
    	context.partEnd();
    }

	private partEnd() {
        var context = this;
		this.scenario.stopAmbientLoop();
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;


		context.scenario.saveScore();

		context.onDone();

		//this.scenario.showBadgingUI(0, () => {
        //    context.onDone();
        //});
	}

    public PreloadUis(shouldHidePatientRecord?: boolean) {
        var context = this;
        this.PrInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.PatientRecordUI, {
            top: [
				{
					description: 'Name: Enrique Ramirez'
				},
				{
					description: 'Room: #6'
				},
				{
					description: 'Age: 32'
				},
				{
					description: 'Sex: Male'
				}
			],
			basic: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).ramirezBasicID),
			nurses: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).ramirezNursesID),
			lab: [
				{
					title: 'Test Name'
				},
				{
					title: 'Results'
				},
				{
					title: 'Normal Range'
				}
			],
			vitals: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).ramirezVitalsID),
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.Remember);
				}, 500);
				this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
				// if(this.RememberDisplayed === false) {
				// 	context.segment1Step4Remember();
				// }
			} 
		});

		if(shouldHidePatientRecord) {
			this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
		} else {
			setTimeout(() => {
				context.scenario.update508Window(Window508Type.PatientRecord);
			}, 500);
		}

		(this.scenario as Scenario2).PrRamirezID = this.PrInstanceID;

		context.TalkInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Talk',
			talks: [
				{
					toppx: '50px',
					titletext: 'How are you feeling?',
					onClicked: () => {
						this.segment1TalkFeeling();
					},
					disable: () => this.Talk1
				},
				{
					toppx: '150px',
					titletext: 'On a scale of 0-10, can you rate your pain?',
					onClicked: () => {
						this.segment1TalkRate();
					},
					disable: () => this.Talk2
				},
				{
					toppx: '250px',
					titletext: 'Can you describe your pain?',
					onClicked: () => {
						this.segment1TalkDescribe();
					},
					disable: () => this.Talk3
				},
				{
					toppx: '350px',
					titletext: 'Would you like something for the pain?',
					onClicked: () => {
						this.segment1TalkPills();
					},
					disable: () => this.Talk4
				},
				{
					toppx: '450px',
					titletext: "Can you wiggle the fingers on your right hand?",
					onClicked: () => {
						this.segment1TalkFinger();
					},
					disable: () => this.Talk5
				},
				{
					toppx: '550px',
					titletext: 'Can you feel my touch on your right arm?',
					onClicked: () => {
						this.segment1TalkTouch();
					},
					disable: () => this.Talk6
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);

		this.ActionInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Action',
			talks: [
				{
					toppx: '50px',
					titletext: 'Take Vitals',
					onClicked: () => {
						this.segment1ActionVitals();
					},
					disable: () => this.Action1
				},
				{
					toppx: '150px',
					titletext: 'Please take a deep breath and then cough.',
					onClicked: () => {
						this.segment1ActionCough();
					},
					disable: () => this.Action2
				},
				{
					toppx: '250px',
					titletext: "Check skin color on patient's right arm",
					onClicked: () => {
						this.segment1ActionSkin();
					},
					disable: () => this.Action3
				},
				{
					toppx: '350px',
					titletext: 'Assess Respiratory Status',
					onClicked: () => {
						this.segment1ActionStatus();
					},
					disable: () => this.Action4
				},
				{
					toppx: '450px',
					titletext: 'Assess chest tube dressing',
					onClicked: () => {
						this.segment1ActionTube();
					},
					disable: () => this.Action5
				},
				{
					toppx: '550px',
					titletext: 'Assess Patient',
					onClicked: () => {
						this.segment1ActionAssess();
					},
					disable: () => this.Action6
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
	}

	private segment1ActionVitals() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.ActionInstanceID2 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Take Vitals',
			talks: [
				{
					toppx: '50px',
					titletext: 'Temperature',
					onClicked: () => {
						context.segment1ActionTemperature();
					},
					disable: () => this.Action11
				},
				{
					toppx: '150px',
					titletext: 'Blood Pressure',
					onClicked: () => {
						context.segment1ActionBloodPressure();
					},
					disable: () => this.Action12
				},
				{
					toppx: '250px',
					titletext: 'Pulse',
					onClicked: () => {
						context.segment1ActionPulse();
					},
					disable: () => this.Action13
				},
				{
					toppx: '350px',
					titletext: 'Respirations',
					onClicked: () => {
						context.segment1ActionRespirations();
					},
					disable: () => this.Action14
				},
				{
					toppx: '450px',
					titletext: 'O2 Sat Level',
					onClicked: () => {
						context.segment1ActionSatLevel();
					},
					disable: () => this.Action15
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1TalkFeeling() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '70px',
			scenario: this,
			loadQuiz: true,
			titletext: 'How are you feeling?',
			isTalks: true,
			extBottom: true,
			extText: "My arm is throbbing and my chest really hurts when I try to take a deep breath.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk1 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 150,
					talktext1: 'Patient Assessment',
					talktext2: 'Pain Location',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'General',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Arm(s)',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Leg(s)',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Head',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Chest',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic49, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic48, () => {}, true);
		});
	}

	private segment1TalkRate() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '170px',
			scenario: this,
			loadQuiz: true,
			titletext: 'On a scale of 0-10, can you rate your pain?',
			isTalks: true,
			isPainScale: true,
			painScaleMaxPoints: 100,
			painScaleCorrect: 5,
			extBottom: true,
			extText: "About a five, I suppose.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.evaluateScoreForPainScale(updatedConfig);
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
					header: 'Pain Scale',
					list: '<li>'+updatedConfig.painAssessment+'</li>',
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
				this.Talk2 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic50, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic48, () => {}, true);
		});
	}

	private segment1TalkDescribe() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '270px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Can you describe your pain?',
			isTalks: true,
			extBottom: true,
			extText: "My arm is throbbing. I get a sharp, stabbing pain in my chest when I try to breathe deeply.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk3 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 200,
					talktext1: 'Patient Assessment',
					talktext2: 'Pain Description',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Stabbing',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Burning',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Sharp',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Tender',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Throbbing',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic51, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic48, () => {}, true);
		});
	}

	private segment1TalkPills() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '370px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Would you like something for the pain?',
			isTalks: true,
			extBottom: true,
			extText: "Yes, please. That would be good.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
					title: context.scenario.medicineAdministered,
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.medicineAdministered)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk4 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 100,
					binaryq: true,
					talktext1: 'Medication Administered',
					talktext2: ' ',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Yes',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic52, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic48, () => {}, true);
		});
	}

	private segment1TalkFinger() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '470px',
			loadQuiz: true,
			scenario: this,
			titletext: "Can you wiggle the fingers on your right hand?",
			isTalks: true,
			extBottom: true,
			extText: "Like this?",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.CMSbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.cmsAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.CMSbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.cmsAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk5 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 3,
					quiztop: '5px',
					maxPoints: 250,
					binaryq: true,
					talktext1: 'CMS Assessment',
					talktext2: 'Movement',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'No movement',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Full range of motion',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Decreased range of motion',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic55, () => { //NEED ANIM REPLACED, WILL BE NEW ANIM NOT SHOWING FACE, SO WE CAN ADD AUDIO TO VIDEO (AUDIO SENT TO ALAN & ED) - alan added audio file to premiere.
			this.playVideoChapter(this.chapterIds.chapterCinematic48, () => {}, true);
		});
	}

	private segment1TalkTouch() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '570px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Can you feel my touch on your right arm?',
			isTalks: true,
			extBottom: true,
			extText: "Yes, I can feel that.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.CMSbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.cmsAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.CMSbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.cmsAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk6 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 3,
					quiztop: '5px',
					maxPoints: 250,
					talktext1: 'CMS Assessment',
					talktext2: 'Sensation',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Decreased sensation',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Normal sensation',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Altered sensation',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -500px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic53, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic48, () => {}, true);
		});
	}

	private segment1ActionTemperature() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			loadQuiz: true,
			titletext: 'Temperature',
			vitaltext: '99.4',
			scenario: this,
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_temp.png',
			onSubmit: () => {
				this.Action11 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
					list: '<li>Temperature : 99.4</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionBloodPressure() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '170px',
			loadQuiz: true,
			titletext: 'Blood Pressure',
			vitaltext: '106/76',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_bp.png',
			scenario: this,
			onSubmit: () => {
				this.Action12 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
					list: '<li>Blood Pressure : 106/76</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionPulse() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			loadQuiz: true,
			titletext: 'Pulse',
			vitaltext: '84',
			scenario: this,
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_pulse.png',
			onSubmit: () => {
				this.Action13 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
					list: '<li>Pulse : 84</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionRespirations() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '370px',
			loadQuiz: true,
			titletext: 'Respirations',
			vitaltext: '20',
			scenario: this,
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_respiration.png',
			onSubmit: () => {
				this.Action14 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
					list: '<li>Respirations : 20</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionSatLevel() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '470px',
			loadQuiz: true,
			titletext: 'O2 Sat Level',
			scenario: this,
			vitaltext: '94% 2L supplemental O2 nasal cannula',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_o2.png',
			onSubmit: () => {
				this.Action15 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
					list: '<li>02 Sat Level : 94% 2L supplemental O2 nasal cannula</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionCough() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			scenario: this,
			toptitle: 'Action',
			toppx: '170px',
			loadQuiz: true,
			titletext: 'Please take a deep breath and then cough.',
			isTalks: true,
			onSubmit: () => {
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.Action2 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts();
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic54, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic48, () => {}, true);
		});
	}

	private segment1ActionSkin() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			scenario: this,
			toptitle: 'Action',
			toppx: '270px',
			loadQuiz: true,
			titletext: "Check skin color on patient's right arm",
			isTalks: true,
			extTop: true,
			extImg: 't17', //NEED IMAGE
			extText: 'Normal for ethnicity', 
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.CMSbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.cmsAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.CMSbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.cmsAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action3 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts();
			},
			quiz: [
				{
					quizheight: 3,
					quiztop: '5px',
					maxPoints: 250,
					talktext1: 'CMS Assessment',
					talktext2: 'Color',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Pale',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Normal for ethnicity',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Cyanotic',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionStatus() {
		var context = this;
		this.playVideoChapter(this.chapterIds.chapterCinematic56, () => {}, true);
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			scenario: this,
			toptitle: 'Action',
			toppx: '370px',
			loadQuiz: true,
			titletext: "Assess Respiratory Status",
			isTalks: true,
			extBottom: true,
			extText: 'Right side: breath sounds are decreased <br>Left Side: breath sounds are normal',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
					title: context.scenario.respiratoryStatus,
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.respiratoryStatus)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action4 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				this.playVideoChapter(this.chapterIds.chapterCinematic48, () => {}, true);
				context.getFooterCounts();
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 150,
					binaryq: true,
					talktext1: 'Respiratory Status',
					talktext2: 'Thoracic Cage Expansion',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Symmetrical',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Asymmetrical',
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 4,
					prequizheight: 2,
					quiztop: '310px',
					maxPoints: 150,
					binaryq: true,
					talktext1: 'Respiratory Status',
					talktext2: 'Breath Sounds',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Absent',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Clear on both sides',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Decreased on left, clear on right',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Decreased on right, clear on left',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionTube() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			scenario: this,
			toptitle: 'Action',
			toppx: '470px',
			loadQuiz: true,
			titletext: "Assess chest tube dressing",
			isTalks: true,
			extTop: true,
			extImg: 't18', //NEED IMAGE
			extText: 'Crepitus is not present',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
					title: context.scenario.chestTube,
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.chestTube)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action5 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 100,
					talktext1: 'Chest Tube and System',
					talktext2: 'Assess Insertion Site',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Bleeding',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Air leakage',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Infection',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Clean and dry',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 2,
					prequizheight: 4,
					quiztop: '410px',
					maxPoints: 100,
					binaryq: true,
					talktext1: 'Chest Tube and System',
					talktext2: 'Is Crepitus present?',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Yes',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionAssess() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.ActionInstanceID3 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Take Vitals',
			talks: [
				{
					toppx: '50px',
					titletext: 'Assess Chest Tube and System: Suction',
					onClicked: () => {
						context.segment1ActionSuction();
					},
					disable: () => this.Action21
				},
				{
					toppx: '150px',
					titletext: 'Assess Chest Tube and System: Drainage Color and Volume',
					onClicked: () => {
						context.segment1ActionDrainage();
					},
					disable: () => this.Action22
				},
				{
					toppx: '250px',
					titletext: 'Assess Chest Tube and System: Tidaling',
					onClicked: () => {
						context.segment1ActionTidaling();
					},
					disable: () => this.Action23
				},
				{
					toppx: '350px',
					titletext: 'Assess Chest Tube and System: Leakage',
					onClicked: () => {
						context.segment1ActionLeakage();
					},
					disable: () => this.Action24
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1ActionSuction() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			scenario: this,
			toptitle: 'Assess Patient',
			toppx: '70px',
			loadQuiz: true,
			titletext: "Assess Chest Tube and System: Suction",
			isTalks: true,
			extTop: true,
			extTopVideo: './assets/videos/general/loop1.mp4',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.DRbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.drainageSystem,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.DRbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.drainageSystem)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action21 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.getFooterCounts();
			},
			quiz: [
				{
					quizheight: 3,
					quiztop: '5px',
					maxPoints: 200,
					binaryq: true,
					talktext1: 'Drainage System',
					talktext2: 'Suction',
					talks: [
						{
							buttontop: '150px',
							buttontext: '-10 cm',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: '-20 cm',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: '-40 cm',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionDrainage() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '170px',
			scenario: this,
			loadQuiz: true,
			titletext: "Assess Chest Tube and System: Drainage Color and Volume",
			isTalks: true,
			extTop: true,
			extTopVideo: './assets/videos/general/loop1.mp4',
			extText: 'Previous shift output is 400mL in 12 hours',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.DRbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.drainageSystem,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.DRbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.drainageSystem)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action22 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.getFooterCounts();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 200,
					talktext1: 'Drainage System',
					talktext2: 'Drainage Color',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Dark red',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Pink',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Clear',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Cloudy',
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 5,
					prequizheight: 4,
					quiztop: '410px',
					maxPoints: 200,
					binaryq: true,
					talktext1: 'Drainage System',
					talktext2: 'Drainage Volume',
					talks: [
						{
							buttontop: '150px',
							buttontext: '0 mL',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: '50 mL',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: '100 mL',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: '600 mL',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: '700 mL',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionTidaling() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '270px',
			loadQuiz: true,
			scenario: this,
			titletext: "Assess Chest Tube and System: Tidaling",
			isTalks: true,
			extTop: true,
			extTopVideo: './assets/videos/general/loop1.mp4',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.DRbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.drainageSystem,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.DRbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.drainageSystem)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action23 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.getFooterCounts();
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 200,
					binaryq: true,
					talktext1: 'Drainage System',
					talktext2: 'Tidaling',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Present',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Not present',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionLeakage() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '370px',
			loadQuiz: true,
			scenario: this,
			titletext: "Assess Chest Tube and System: Leakage",
			isTalks: true,
			extTop: true,
			extTopVideo: './assets/videos/general/loop1.mp4',
			extText: 'There is no air leakage',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.DRbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.drainageSystem,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.DRbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.drainageSystem)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action24 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.getFooterCounts();
			},
			quiz: [
				{
					quizheight: 3,
					quiztop: '5px',
					maxPoints: 200,
					binaryq: true,
					talktext1: 'Drainage System',
					talktext2: 'Leakage',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Presistent leakage',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Intermittent leakage',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'No air leakage',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.segment2EventOccurs();
		}
		else if(this.TalkCount === 0 && this.ActionCount !== 0) {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		}
		else if(this.TalkCount !== 0 && this.ActionCount === 0) {
			context.scenario.updateFooter(this.TalkCount.toString(), '0', false, true);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), false, false)
		};
	}

	private checkIfSubMenu() {
		var context = this;
		if(this.Action11 === true && this.Action12 === true && this.Action13 === true && this.Action14 === true && this.Action15 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.ActionCount = this.OldActionCount - 1;
			this.Action1 = true;
		};
		context.getFooterCounts();
	}

	private segment2EventOccurs() {
		var context = this;
		context.scenario.gameManager.environment.blurFadeIn();
		setTimeout(() => {
			this.playVideoChapter(this.chapterIds.chapterCinematic57, () => {}, true);
			this.scenario.displayModalPop(
				null,
				'The chest tube has been dislodged.',
				() => {
					context.scenario.destroyAllUIInstances();
					context.segment2PreloadUis();
				}
			);
		}, 1000)
		setTimeout(() => {
			context.scenario.gameManager.environment.blurFadeOut();
		}, 1500);
	}

	private segment2PreloadUis() {
        var context = this;
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
			visit: context.scenario.visit2,
			lineBreak: true,
		});
		context.scenario.gameManager.UiManager.updateUIInstance(this.ActionInstanceID1, {
			talks: [
				{
					toppx: '50px',
					titletext: 'Please take a deep breath and then cough.',
					onClicked: () => {
						this.segment2ActionCough();
					},
					disable: () => this.Action31
				},
				{
					toppx: '150px',
					titletext: 'Adjust Bed',
					onClicked: () => {
						this.segment2ActionBed();
					},
					disable: () => this.Action32
				},
				{
					toppx: '250px',
					titletext: 'Cover insertion site',
					onClicked: () => {
						this.segment2ActionSite();
					},
					disable: () => this.Action33
				},
				{
					toppx: '350px',
					titletext: 'Contact Provider',
					onClicked: () => {
						this.segment2ActionProvider();
					},
					disable: () => this.Action34
				},
				{
					toppx: '450px',
					titletext: 'Call RRT',
					onClicked: () => {
						this.segment2ActionRRT();
					},
					disable: () => this.Action35
				}
			]
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		context.ActionCount = 5;
		context.getFooterCounts2();
	}

	private segment2ActionCough() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Please take a deep breath and then cough.',
			isTalks: true,
			onSubmit: () => {
				context.scenario.updateScore(250);
				this.Action31 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic70, () => {
			if(this.bedUp) {
				this.playVideoChapter(this.chapterIds.chapterCinematic58, () => {}, true);
			}
			else this.playVideoChapter(this.chapterIds.chapterCinematic57, () => {}, true);
		});
	}

	private segment2ActionBed() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '170px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Adjust Bed',
			isTalks: true,
			onSubmit: () => {
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					binaryq: true,
					talktext1: ' ',
					talktext2: 'Adjust Bed',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Semi-Fowlers position',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'High Fowlers position',
							isCorrect: true, //ALL OTHER OPTIONS WILL SHOW MODAL FEEDBACK
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Supine position',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Trendelenburg',
							onClicked: () => {
							},
						}
					],
					setFailed: true,
					failedOnDone: () => {
						this.scenario.displayModalPop(
							null,
							'This is the incorrect bed positioning for this situation. Try again.',
							() => {
								context.scenario.destroyAllUIInstances();
								context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
							}
						);
					},
					passedOnDone: () => {
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							title: 'Adjust Bed',
							header: 'Adjust Bed',
							list: 'High Fowlers position',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
						context.scenario.updateScore(250);
						this.Action32 = true;
						this.ActionCount = this.OldActionCount - 1;
						context.scenario.destroyAllUIInstances();
						context.scenario.gameManager.environment.blurFadeIn();
						setTimeout(() => {
							this.bedUp = true;
							this.playVideoChapter(this.chapterIds.chapterCinematic58, () => {}, true);
						}, 1000)
						setTimeout(() => {
							context.scenario.gameManager.environment.blurFadeOut();
							context.scenario.update508Window(Window508Type.TalkActionsUI);
						}, 1500);
						this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
						context.getFooterCounts();
					}
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionSite() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Cover Insertion Site',
			isTalks: true,
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
					title: 'Replace Dressing',
					header: 'Cover insertion site',
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2)
					}
				}
				this.Action33 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 750,
					talktext1: 'Replace Dressing',
					talktext2: ' ',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Use sterile guaze',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Tape all four sides of dressing',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Tape three sides of dressing',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Do not cover insertion site',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionProvider() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.destroyAllUIInstances();
		context.scenario.hideFooter();
		this.Action34 = true;
		context.getFooterCounts2();
	}

	private segment2ActionRRT() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.destroyAllUIInstances();
		context.scenario.hideFooter();
		this.Action35 = true;
		this.playVideoChapter(this.chapterIds.chapterCinematic76, () => {
			context.scenario.gameManager.environment.blurFadeIn();
			context.getFooterCounts2();
		});
	}

	private getFooterCounts2() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.Action34 === true) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.hideFooter();
			context.segment2PartEndingStart();
		}
		else if(this.Action35 === true) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.hideFooter();
			context.scenario.gameManager.environment.blurFadeOut();
			context.segment1Part5Debrief();
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), true, false)
		};
	}

	private segment2PartEndingStart() {
		var context = this;
		context.scenario.gameManager.environment.blurFadeIn();
		context.scenario.showProvider(
			"Hi Nurse, what's the situation?",
			() => {
				context.segment2showSbar();
			}
		);
	}

	private segment2showSbar() {
		var context = this;
		context.scenario.update508Window(Window508Type.SbarUI)
		this.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.SbarUI, {
			s: {
				maxPoints: 250,
				options: [
					{
						text: 'Chest Tube was inadvertently dislodged',
						isCorrect: true
					},
					{
						text: 'Chest tube insertion site is infected',
						isCorrect: false
					},
					{
						text: 'chest tube is blocked',
						isCorrect: false
					},
					{
						text: 'Insertion site is infected',
						isCorrect: false
					}
				]
			},
			basic: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).ramirezBasicID),
			nurses: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).ramirezNursesID),
			r: {
				maxPoints: 250,
				options: [
					{
						text: 'Replace Chest Tube',
						isCorrect: true
					},
					{
						text: 'X-ray to validate placement',
						isCorrect: true
					},
					{
						text: 'CT Scan',
						isCorrect: false
					},
					{
						text: 'Medication for pain',
						isCorrect: false
					}
				]
			},
			correctFeedback: 'Good job, you have correctly relayed critical information. Please review the SBAR and continue.',
			incorrectFeedback: 'You have incorrectly relayed critical information. Accurate patient information ensures patient safety and quality care provided by medical staff and Providers. Please continue to review the corrected SBAR.',
			onSubmitted: (result: SbarUIConfig) => {
				this.scenario.evaluateScoreForSbar(result);
			},
			onClose: (result: SbarUIConfig) => {
				context.scenario.destroyAllUIInstances();
				context.showFullPageQuiz();
			},
			onSetWindow: (window: Window508Type) => {
				context.scenario.update508Window(window);
			}
		});
	}

	private showFullPageQuiz() {
		var context = this;
		context.scenario.update508Window(Window508Type.FullPageQuiz)
		var FPinstance = this.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.FullPageQuizUI, {
			questions: [
				{
					title: 'What steps do you need to take to prepare for a chest tube insertions',
					multipleChoice: true,
					options: [
						{
							title: 'Adjust bed for High Fowlers Position',
							isCorrect: true,
							points: 0
						},
						{
							title: 'Adjust bed to Trendelenburg',
							isCorrect: false,
							points: 0
						},
						{
							title: 'Prepare chest tube tray',
							isCorrect: true,
							points: 0
						},
						{
							title: 'Monitor Oxygenation and vital signs',
							isCorrect: true,
							points: 0
						},
						{
							title: 'Reinsert chest tube',
							isCorrect: false,
							points: 0
						}
					],
					incorrectFeedback: "Trendelenburg position would be detrimental to your patient because it would increase the breathing difficulty. Reinserting the chest tube is not within the nurse's scope of practice. Wait for the Provider to arrive."
				},
			],
			onSingleQuestionSubmitted: (question: FullPageQuizQuestion) => {
				var correctOptions = question.options.filter(o => o.isCorrect);
				
				var correctPoints = 0;
				correctOptions.forEach(co => correctPoints += co.points);

				var selectedOptions = question.options.filter(o => o.isSelected);
				var correctSelectedOptions = question.options.filter(o => o.isCorrect && o.isSelected);
				var isCorrect = correctOptions.length === correctSelectedOptions.length && selectedOptions.length === correctOptions.length;
				if(isCorrect) {
					//
				} else {
					this.scenario.gameManager.UiManager.hideUiInstance(FPinstance);
					this.scenario.showFeedback(question.incorrectFeedback, () => {
						this.scenario.gameManager.UiManager.showUiInstance(FPinstance);
						this.scenario.update508Window(Window508Type.FullPageQuiz)
					})
				}

				return isCorrect;
			},
			onDone: () => {
				context.scenario.gameManager.UiManager.destroyUIInstanceById(FPinstance);
				context.scenario.update508Window(Window508Type.TalkActionsUI)
				context.scenario.showProvider(
					"I'll be right there.",
					() => {
						context.scenario.destroyAllUIInstances();
						context.segment2AfterFP();
					}
				);
			}
		});	
	}

	private segment2AfterFP() {
		var context = this;
		context.scenario.gameManager.environment.blurFadeOut();
		this.playVideoChapter(this.chapterIds.chapterCinematic60, () => {
			context.scenario.gameManager.environment.blurFadeIn();
			context.segment2AfterFP2();
		});
		context.scenario.showProvider(
			"Okay, I understand we have a dislodged chest tube. Let's get that replaced.",
			() => {
				context.scenario.destroyAllUIInstances();
				//context.segment2AfterFP2();
			}
		);
	}

	private segment2AfterFP2() {
		var context = this;
		setTimeout(() => {
			context.scenario.gameManager.environment.blurFadeOut();
			this.playVideoChapter(this.chapterIds.chapterCinematic61, () => { 
				//context.scenario.gameManager.environment.blurFadeIn();
			});
			context.scenario.showProvider(
				"Okay, that should be good. I'll order an x-ray to confirm placement.",
				() => {
					context.scenario.destroyAllUIInstances();
					context.scenario.gameManager.environment.blurFadeOut();
					this.playVideoChapter(this.chapterIds.chapterCinematic62, () => {
						context.segment1Part5Debrief();
					});
				}
			);
		}, 3000);
		setTimeout(() => {
			context.scenario.gameManager.environment.blurFadeIn();
		}, 6000);
		setTimeout(() => {
			context.scenario.gameManager.environment.blurFadeIn();
		}, 7000);
	}
}